import {Col, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import React, {Children, Fragment, ReactElement, ReactNode, useState} from "react";
import {Row} from "react-bootstrap";

interface BootstrapTabContainerProps {
    children: ReactNode;
    horizontal?: boolean;
}

interface BootstrapTabContentProps {
    title?: string;
    icon?: string;
    children?: ReactNode;
}

export const BootstrapTabContainer = ({children, horizontal = true}: BootstrapTabContainerProps) => {
    const [activeTab, setActiveTab] = useState(0);
    const arrayChildren = Children.toArray(children);

    const getNavTabs = () => {
        return Children.map(arrayChildren, (child, index) => {
            const childElement = child as ReactElement<BootstrapTabContentProps>;
            return <NavItem>
                <NavLink className={activeTab === index ? 'active' : ''}
                         onClick={() => setActiveTab(index)}>
                    {childElement.props?.icon ? <i className={childElement.props?.icon}/> : null}
                    {childElement.props?.title}
                </NavLink>
            </NavItem>
        })
    }

    const getNavTabData = () => {
        return Children.map(arrayChildren, (child, index) => {
            const childElement = child as ReactElement<BootstrapTabContentProps>;
            return <TabPane className='fade show' tabId={index}>
                {activeTab === index && childElement.props?.children}
            </TabPane>
        })
    }
    return (
        horizontal ? <Fragment> <Nav className='border-tab' tabs style={{overflow: 'auto', scrollbarWidth: 'none'}}>
            {getNavTabs()}
        </Nav>
            <TabContent activeTab={activeTab}>
                {getNavTabData()}
            </TabContent></Fragment> : <Row> <Col md={3}><Nav className='nav flex-column nav-pills' tabs>
            {getNavTabs()}
        </Nav></Col>
            <Col md={9}><TabContent activeTab={activeTab}>
                {getNavTabData()}
            </TabContent></Col></Row>
    )
}
export const BootstrapTabContent = ({title, icon, children}: BootstrapTabContentProps) => {
    return (<Fragment/>);
}
